export const SIGNUP_TEST_KEY = 'ws-0006';
export const LOGIN_DESIGN_TEST_KEY = 'ws-0013';